var _excluded = ["part", "prefix", "position", "enableDragMask", "dragMaskSelectType", "enableDragMaskReverseMode", "enableInvalidTooltip", "both"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { memo } from 'react';
import { useToggle } from '@okee-uikit/react-hooks';
import { useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { PanelType, useViewWrapper } from '../../../hooks/date';
import { Popover } from '../../../components/popover/Popover';
import { DateView } from '../views/DateView';
import { MonthView } from '../views/MonthView';
import { WeekView } from '../views/WeekView';
import { YearView } from '../views/YearView';
export var ViewWrapper = memo(function (props) {
  var part = props.part,
      prefix = props.prefix,
      position = props.position,
      _props$enableDragMask = props.enableDragMask,
      enableDragMask = _props$enableDragMask === void 0 ? false : _props$enableDragMask,
      _props$dragMaskSelect = props.dragMaskSelectType,
      dragMaskSelectType = _props$dragMaskSelect === void 0 ? 'cover' : _props$dragMaskSelect,
      _props$enableDragMask2 = props.enableDragMaskReverseMode,
      enableDragMaskReverseMode = _props$enableDragMask2 === void 0 ? false : _props$enableDragMask2,
      _props$enableInvalidT = props.enableInvalidTooltip,
      enableInvalidTooltip = _props$enableInvalidT === void 0 ? false : _props$enableInvalidT,
      both = props.both,
      extra = _objectWithoutProperties(props, _excluded);

  var _useViewWrapper = useViewWrapper(part),
      currentPanelType = _useViewWrapper.currentPanelType,
      ownerType = _useViewWrapper.ownerType,
      isOwner = _useViewWrapper.isOwner,
      hideNext = _useViewWrapper.hideNext,
      hidePrev = _useViewWrapper.hidePrev,
      disabled = _useViewWrapper.disabled,
      outRangeDisabled = _useViewWrapper.outRangeDisabled,
      invalid = _useViewWrapper.invalid;

  var locale = useLocale('date-picker.invalid-range');

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 3),
      show = _useToggle2[0],
      onShow = _useToggle2[1],
      onHide = _useToggle2[2];

  var content;
  var hideNextFinal = !both && hideNext && isOwner;
  var hidePrevFinal = !both && hidePrev && isOwner;

  switch (currentPanelType) {
    case PanelType.DATE:
      content = React.createElement(DateView, _objectSpread(_objectSpread({}, extra), {}, {
        prefix: prefix,
        part: part,
        owner: ownerType,
        position: position,
        enableDragMask: enableDragMask && !disabled && isOwner,
        enableInvalidTooltip: enableInvalidTooltip,
        dragMaskSelectType: dragMaskSelectType,
        enableDragMaskReverseMode: enableDragMaskReverseMode,
        prevDateItemDisabled: outRangeDisabled,
        nextDateItemDisabled: outRangeDisabled,
        hideNextMonth: hideNextFinal,
        hidePrevMonth: hidePrev,
        hideNextYear: hideNextFinal,
        hidePrevYear: hidePrev
      }));
      break;

    case PanelType.YEAR:
      content = React.createElement(YearView, _objectSpread(_objectSpread({}, extra), {}, {
        owner: ownerType,
        part: part,
        prefix: prefix,
        position: position,
        enableInvalidTooltip: enableInvalidTooltip,
        enableDragMask: enableDragMask && !disabled && isOwner,
        dragMaskSelectType: dragMaskSelectType,
        enableDragMaskReverseMode: enableDragMaskReverseMode,
        prevYearItemDisabled: outRangeDisabled,
        nextYearItemDisabled: outRangeDisabled,
        hideNextTenYear: hideNextFinal,
        hidePrevTenYear: hidePrev
      }));
      break;

    case PanelType.WEEK:
      content = React.createElement(WeekView, _objectSpread(_objectSpread({}, extra), {}, {
        owner: ownerType,
        part: part,
        prefix: prefix,
        position: position,
        enableInvalidTooltip: enableInvalidTooltip,
        hideNextMonth: hideNextFinal,
        hidePrevMonth: hidePrevFinal,
        hideNextYear: hideNextFinal,
        hidePrevYear: hidePrevFinal
      }));
      break;

    case PanelType.MONTH:
      content = React.createElement(MonthView, _objectSpread(_objectSpread({}, extra), {}, {
        owner: ownerType,
        part: part,
        prefix: prefix,
        position: position,
        enableInvalidTooltip: enableInvalidTooltip,
        dragMaskSelectType: dragMaskSelectType,
        enableDragMaskReverseMode: enableDragMaskReverseMode,
        enableDragMask: enableDragMask && !disabled && isOwner,
        hidePrevYear: hidePrevFinal,
        hideNextYear: hideNextFinal
      }));
  }

  var popperCls = usePrefixCls('date', {
    popper: true
  }, true);
  var popper = React.createElement("div", {
    className: popperCls
  }, locale);

  if (enableInvalidTooltip) {
    return React.createElement(Popover.Singleton, {
      placement: "top",
      arrow: true,
      lazyInit: true,
      getPopper: popper,
      hideToDestroy: true,
      show: show && invalid && isOwner,
      onShow: onShow,
      onHide: onHide
    }, content);
  }

  return content;
});